// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"539488dd","239":"2f822dd7","396":"c34b75af","455":"613fd633","857":"1279aa4b","977":"1ff7fdd1"}[chunkId] + ".chunk.js";
};